// extracted by mini-css-extract-plugin
module.exports = {"base":"Separator_base__2kP0d","semiBold":"Separator_semiBold__9Eu4c","bold":"Separator_bold__412WT"};